// components
import Loader from 'components/Loader';
//
import { AuthContext } from './auth-context';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export function AuthConsumer({ children }: Props) {
    return <AuthContext.Consumer>{(auth) => (auth.loading ? <Loader /> : children)}</AuthContext.Consumer>;
}
